export default {
  install(Vue, { store }) {
    Vue.prototype.$can = function (permission) {
      const { permissions } = store.state.autenticacao
      return permissions.includes(permission) || false
    }
  },
}
